var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "googleAnalytics",
    transform: "translate(119 -2471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 150,
    height: 150,
    transform: "translate(-119 2471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6628",
    transform: "translate(-99.319 2483.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3806",
    d: "M269.9,354.1v93.75c0,10.5,7.362,16.335,15.175,16.335,7.226,0,15.175-4.972,15.175-16.335v-93.04c0-9.61-7.226-15.625-15.175-15.625S269.9,345.817,269.9,354.1Zm0,0",
    transform: "translate(-190.408 -339.181)",
    fill: "#f8ab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3808",
    d: "M222.423,412.187v46.97c0,10.681,7.362,16.62,15.175,16.62,7.226,0,15.175-5.058,15.175-16.62V412.91c0-9.778-7.226-15.9-15.175-15.9A15.431,15.431,0,0,0,222.423,412.187Zm0,0",
    transform: "translate(-182.679 -350.778)",
    fill: "#e37300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3810",
    d: "M205.3,470.018a15.175,15.175,0,1,1-15.175-15.175A15.179,15.179,0,0,1,205.3,470.018",
    transform: "translate(-174.949 -360.193)",
    fill: "#e37300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/googleAnalytics.d95e570129cd5ae82f4f3fbf8b314b2f.svg";
export { ForwardRef as ReactComponent };